function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M110,3.139C110,1.407 108.593,0 106.861,0L3.139,0C1.407,0 0,1.407 0,3.139L0,106.861C0,108.593 1.407,110 3.139,110L106.861,110C108.593,110 110,108.593 110,106.861L110,3.139Z",
    style: {
      fill: "rgb(229,239,244)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.803,90.475L31.803,86.14C31.803,79.638 37.073,74.368 43.575,74.368L64.424,74.368C70.925,74.368 76.196,79.638 76.196,86.14L76.196,90.475M43.214,50.932C43.214,55.046 44.188,63.503 52.929,63.503C61.67,63.503 62.857,54.718 62.857,50.932M66.786,39.932C66.786,35.817 65.422,27.36 53.185,27.36C40.947,27.36 39.285,36.145 39.285,39.932M31.776,43.074L74.226,43.074M53.018,20.39L53.036,35.13",
    style: {
      fill: "none",
      stroke: "rgb(1,113,183)",
      strokeWidth: "3.92px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,27.5721,-12.0087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.984,41.9L46.428,46.979",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(250,166,26)",
      strokeWidth: "1.57px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.005,39.4L37.926,39.845",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(249,173,46)",
      strokeWidth: "1.57px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.666,44.188L48.704,40.98M43.506,36.771L39.545,33.563M40.292,45.424L43.637,41.577M48.042,35.953L51.92,32.048M44.804,30.173L45.599,35.349M54.525,37.604L49.828,38.015",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(250,166,26)",
      strokeWidth: "1.57px"
    }
  }))));
};
export default SvgProfile;